<template>
  <div>
      <p v-if="error" class="text-danger">{{ errorMsg }}</p>

      <div class="">

          <div
              v-if="loading"
              key="isLoading"
              class="min-height-200"
              style="height: 200px;"
          >
              <busy-spinner></busy-spinner>
          </div>

          <div
              v-else
              key="notLoading"
          >

              <div 
                  v-if="items.length"
                  key="hasItems"
                  class="d-flex flex-wrap gap-5"
              >  <!-- class="row row-cols-1 row-cols-md-2 row-cols-xl-3" -->
                  <div
                      v-for="item in items"
                      :key="item.id"
                      class="max-width-350 min-width-350 flex-fill"
                  >  <!-- class="col mb-3" -->
                      <div
                          class="response-card h-100 border rounded-lg shadow-sm bg-white overflow-hidden d-flex flex-column"
                      >
                          <div
                              class="px-3 py-3 response-card-top bg-gray-100"
                          >
                              <div class="mb-2 d-flex justify-content-between">
                                  <h5 class="mb-0">{{ item.title }}</h5>
                                  <div class="flex-shrink-1 text-uppercase text-right font-weight-700 font-size-100 text-gray-400 mb-0">{{ item.workflow_spec_name }}</div>
                              </div>
                              <div class="d-flex align-items-center justify-content-between">
                                  <div>
                                      <status-object-badge 
                                          :status-object="item.state_dict" 
                                          text-uppercase
                                          font-size="0.8rem"
                                      ></status-object-badge>
                                  </div>
                                  <!-- put "NEEDS YOUR ATTENTION badge here" -->
                              </div>
                          </div>
                           <div class="flex-fill px-3 py-3 response-card-middle d-flex align-items-center justify-content-center">
                              <div class="h-100 d-flex flex-column gap-4">

                                  <!-- <div 
                                      v-if="hasDeadline(item)"
                                      class="w-100 d-flex align-items-center"
                                  >
                                      <div class="width-100">
                                          <div class="font-weight-500 text-uppercase text-muted text-right font-size-70 mb-1">Response<br>Deadline</div>
                                      </div>
                                      <div class="ml-4 width-150">
                                          <div class="">
                                              <p class="mb-0">{{ formatDateTimeLocal(item.rfx.close_date_to_show) }}</p>
                                              <p class="mb-0 text-muted">{{ getHumanizedDateTime(item.rfx.close_date_to_show) }}</p>
                                          </div>
                                      </div>
                                  </div>

                                  <div class="w-100 d-flex align-items-center">
                                      <div class="width-100">
                                          <div class="font-weight-500 text-uppercase text-muted text-right font-size-70 mb-1">Response<br>Status</div>
                                      </div>
                                      <div class="ml-4 width-150">
                                          <status-object-badge 
                                              :status-object="item.response.state_dict"
                                              text-uppercase
                                              font-size="0.8rem"
                                          ></status-object-badge>

                                          <div 
                                              v-if="showNeedsAttention(item)" 
                                              v-b-tooltip.hover
                                              :title="item.response.needs_attention_external_text"
                                              class="d-inline-block text-danger font-size-70 font-weight-bold text-center my-1"
                                          >
                                              <b-icon icon="exclamation-circle-fill" variant="danger" class="mr-1"></b-icon>
                                              NEEDS ATTENTION
                                          </div>
                                      </div>
                                  </div> -->
                              
                              </div>
                          </div>
                          <div
                              class="d-flex border-top response-card-buttons"
                          >
                              <div class="flex-equal p-1">
                                  <b-button 
                                      variant="sharp-primary" 
                                      size="md" 
                                      block
                                      class="text-uppercase py-2" 
                                      :href="item.urls.external_detail" 
                                      target="_blank"
                                  >
                                      <div class="d-flex justify-content-center align-items-center">
                                          <div class="button-text">View Issue</div>
                                          <!-- <b-icon icon="chevron-right" class="ml-2"></b-icon> -->
                                      </div>
                                  </b-button>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          
              <div 
                  v-else
                  key="noEvents"
                  class="col-12 mx-auto"
              >
                  <div class="p-4 text-muted text-center border rounded-lg" style="background-color: rgba(255,255,255,0.3)">
                      <div>
                          You have no open Quality Issues right now.
                      </div>
                      <div class="mt-4">
                          <b-icon icon="inbox" font-scale="4" class="text-secondary-lighter"></b-icon>
                      </div>
                  </div>
                  
              </div>
          
          </div>

      </div>

  </div>
</template>

<script>
//import BaseTablePagination from './BaseTablePagination';
//import StatusObjectBadge from '../functional-comps/StatusObjectBadge';
//import DateTimeDeadline from './table-cell-comps/DateTimeDeadline';
//import { splAxiosBare } from '../../js/api-service';
import { suppliosApi } from '../../js/api-service';
import { WorkflowRun } from './workflow_models';
import { errorHandling } from '../../js/custom-vue-mixins';
import { HumanizeDateTimeHelper, FormatDateTimeLocal, isFutureDate } from '../../js/filters-helpers';

export default {
  name: 'VendorPortalWorkflowCards',
  components: {
      //BaseTablePagination,
      //DateTimeDeadline,
      //StatusObjectBadge,
  },
  mixins: [
      errorHandling,
  ],
  props: {
  },
  data: function() {
      return {
          errorMsg: 'Error',
          error: false,
          loading: false,
          // paginated response
          count: null,  // from API data.count
          items: [],  // 
      }
  },
  computed: {
      totalRows: function() {
          return this.items.length;
      }
  },
  mounted() {
      this.getList();
  },
  methods: {

      async getList() {
          this.loading = true;
          try {
              const { data } = await suppliosApi.workflowRun.get_list_external();
              // data might have 'results' if paginated (and count, next, previous)
              this.count = data.count;
              this.items = data.results.map(i => new WorkflowRun(i)); 
          } catch (err) {
              this.apiErrorHandler(err);
          }
          this.loading = false;
      },
      // METHODS FOR INDIVIDUAL ITEMS IN LIST 
      // once you stabilize the schema, you can make a separate component for each Rfx/RfxResponse
      getHumanizedDateTime(isoString) {
          return HumanizeDateTimeHelper(isoString);
      },
      formatDateTimeLocal(isoString) {
          return FormatDateTimeLocal(isoString);
      },
      hasDeadline(item) {
          // return boolean if we have a deadline to show or not, and its in the future
          const maybeDeadline = item.rfx.close_date_to_show;
          console.log(maybeDeadline);
          return !!maybeDeadline && isFutureDate(maybeDeadline);
      },
      showNeedsAttention(item) {
          // only actually show 'NEEDS ATTENTION' if it has been submitted, 
          // otherwise, just the normal 'Not Submitted' is enough for new invites
          return item.response.state_dict?.is_submitted && item.response.needs_attention_external;
      },
  }
}
</script>

<style>

</style>
